// src/Dashboard/pages/user/Produits/components/EmptyState.jsx

import React from "react";
import { FaSearch } from "react-icons/fa";

export default function EmptyState({
  title = "Aucun élément à afficher",
  description = "Modifiez votre recherche ou vos filtres.",
}) {
  return (
    <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 p-10 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <FaSearch className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        {title}
      </h3>

      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
        {description}
      </p>
    </div>
  );
}